import { toFixed } from "@shared/utils/numbers";
import {
  isEditableTargetZone,
  isTargetZone,
} from "@shared/features/signals/common/utils";
import { ICON_TYPES } from "@shared/common/constants";
import { SignalDetailsContext } from "@shared/features/signals/common/SignalDetails.context";
import { useContext } from "react";
import { EditTargetOrZone } from "@shared/features/signals/EditSignal/types";

interface UseTargetCardPropsProps {
  target: EditTargetOrZone;
  isEdit?: boolean;
}

const useTargetCard = ({ target, isEdit }: UseTargetCardPropsProps) => {
  const { priceCoin, pricePrecision } = useContext(SignalDetailsContext)!;

  const getRatio = (shouldDisplayPreviousRatioValue?: boolean) => {
    const convertRatioToPercent = (ratioToConvert: number | null) => {
      const percentPrecision = 2;

      const percent = 100 * (ratioToConvert || 0);
      return ratioToConvert !== null
        ? toFixed(percent, percentPrecision) + "%"
        : NO_RATIO_TEXT;
    };

    if (isTargetZone(target)) {
      return convertRatioToPercent(MAX_DEFAULT_RATIO);
    }

    if (isEdit) {
      return convertRatioToPercent(
        shouldDisplayPreviousRatioValue ? target.ratio : target.edit_ratio
      );
    }
    return convertRatioToPercent(target.ratio);
  };

  const ratioChanged =
    !isEditableTargetZone(target) && target.ratio !== target.edit_ratio;

  const getPriceData = (target_price: string | [string, string]) => {
    const props = {
      iconType: ICON_TYPES.COIN,
      coinOrExchangeName: priceCoin,
      precision: pricePrecision,
    };

    if (Array.isArray(target_price)) {
      const [minPrice, maxPrice] = target_price;
      return [
        { ...props, text: parseFloat(minPrice) },
        { ...props, text: parseFloat(maxPrice) },
      ];
    } else return [{ ...props, text: parseFloat(target_price) }];
  };

  return {
    getRatio,
    getPriceData,
    ratioChanged,
  };
};

export default useTargetCard;

const NO_RATIO_TEXT = "No Ratio";
const MAX_DEFAULT_RATIO = 1;
